var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrevBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74552 9.5921L3.93402e-07 5.0921L3.74552 0.592102L6 0.592102L2.25448 5.0921L6 9.5921L3.74552 9.5921Z",
    fill: "#35C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrevBlue);
export default __webpack_public_path__ + "static/media/arrow-prev-blue.42fe61d5364e31279d3211e156632df4.svg";
export { ForwardRef as ReactComponent };